import config from '@/config/env'
import axios from 'axios'
import qs from 'qs'
import { Message,Loading } from "element-ui";
import Router from '@/router/index'
import { myDebounce } from '../utils/common'

let baseUrl = window.g.host;

let loading
//当前正在请求的数量
let requestCount = 0
function showLoading() {
  if (requestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: "Loading...",
      background: 'rgba(255, 255, 255, 0.5)',
      target: "body"
    })
  }
  requestCount++
}
  
//隐藏loading
function hideLoading() {
    requestCount--
    requestCount = Math.max(requestCount, 0)
    if (requestCount === 0) {
        toHideLoading()
    }
}
var toHideLoading = myDebounce(()=>{
    loading.close()
    loading = null
  }, 300)

let axiosConfig = {
    baseURL: baseUrl,
    headers: {
        // 'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded'
    },
    // transformRequest: [function(data) {
    //     let ret = ''
    //     for (let it in data) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //     }
    //     return ret
    // }],
    timeout: 30000
}
var instance = axios.create(axiosConfig)
//请求拦截器
instance.interceptors.request.use(config => {
    if(config.headers.showLoading !== false){
        showLoading()
    }
    return config
}, err => {
    if(config.headers.showLoading !== false){
        hideLoading()
    }
    return Promise.resolve(err)
})

function userFunc() {
    let user = null
    if (sessionStorage.getItem('userToken')) {
        user = JSON.parse(sessionStorage.getItem('userToken'))
    }
    return user
}

var service = {
    //  与服务器进行post交互
    async post(api, sendData, format) {
        let user = userFunc()
        if (user) {
            instance.defaults.headers['Authorization'] = user
            instance.defaults.headers['accept-language'] = 'zh-CN'
        }
        if (Object.prototype.toString.call(sendData) === '[object FormData]' || format) {
            sendData = sendData
        } else {
            sendData = qs.stringify(sendData) || {}
        }
        let promise = new Promise(function(resolve, reject) {
            instance
                .post(api, sendData)
                .then((response) => {
                    if(response.config.headers.showLoading !== false){
                        hideLoading()
                    }
                    if (response && (response.status === 200 || response.status === 201)) {
                        let data = response.data
                        if (Number(data.code) === 200) {
                            resolve(data)
                        } else if (Number(data.code) === 401) {
                            Router.push({ path: '/login' })
                            Message.error('登录失效，请重新登录')
                            sessionStorage.clear()
                            localStorage.clear()
                            resolve(false)
                        } else {
                            Message.error(data.msg)
                            resolve(false)
                        }
                    } else if (!response) {
                        Message.error('请求超时，请稍后再试.')
                        resolve(false)
                    } else {
                        Message.error('请求失败')
                        resolve(false)
                    }
                })
                .catch((error) => {
                    if(error.config.headers.showLoading !== false){
                        hideLoading()
                    }
                    if (error.response.data.code == 401) {
                        Router.push({ path: '/login' })
                        Message.error('登录失效，请重新登录')
                        sessionStorage.clear()
                        localStorage.clear()
                    } else {
                        Message.error(error.response.data.msg)
                    }
                    resolve(false)
                })
        })
        return promise
    },
    get(api, sendData) {
        let user = userFunc()
        sendData = sendData || {}
        if (user) {
            instance.defaults.headers['Authorization'] = user
            instance.defaults.headers['accept-language'] = 'zh-CN'
        }
        let promise = new Promise(function(resolve, reject) {
            instance
                .get(api, {
                    params: sendData
                })
                .then((response) => {
                    if(response.config.headers.showLoading !== false){
                        hideLoading()
                    }
                    if (response && response.status === 200) {
                        let data = response.data
                        if (Number(data.code) === 200) {
                            resolve(data)
                        } else if (Number(data.code) === 401) {
                            Router.push({ path: '/login' })
                            Message.error('登录失效，请重新登录')
                            sessionStorage.clear()
                            localStorage.clear()
                            resolve(false)
                        } else {
                            Message.error(data.message)
                            resolve(false)
                        }
                    } else if (!response) {
                        Message.error('请求超时，请稍后再试.')
                        resolve(false)
                    } else {
                        Message.error('请求失败')
                        resolve(false)
                    }
                })
                .catch((error) => {
                    if(error.config.headers.showLoading !== false){
                        hideLoading()
                    }
                    resolve(false)
                })
        })

        return promise
    }
}

export default service